import { Component, OnInit, Input, ViewChild, OnChanges } from '@angular/core';
import { Agent } from 'core/models/agent';
import { QuestionBase, AgentsQuestion, DynamicFormComponent, QuestionGroup } from 'core/components/forms';
import { TranslateService } from '@ngx-translate/core';
import { AgentsCacheService, AgentsService } from 'core/services/';
import { ModalComponent } from 'core/components/';

@Component({
  selector: 'lms-transfer-agent-accounts',
  templateUrl: './transfer-agent-accounts.component.html',
  styleUrls: ['./transfer-agent-accounts.component.scss']
})
export class TransferAgentAccountsComponent implements OnInit, OnChanges {
  @Input() agent: Agent;
  public roleName: string;
  public questions: QuestionBase<any>[] = [];
  public results: any[];
  @ViewChild(DynamicFormComponent, { static: false }) public dynamicForm: DynamicFormComponent;
  @ViewChild(ModalComponent, { static: false }) public modal: ModalComponent;
  constructor(
    public agentsCache: AgentsCacheService,
    public agentsService: AgentsService,
    public translate: TranslateService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    this.roleName = this.translate.instant(`agents.roles.${this.agent.role}`);
    this.questions = [
      new QuestionGroup({
        key: 'agentIds',
        controlType: 'agents',
        value: [],
        childQuestions: [
          new AgentsQuestion({
            key: 'agentList',
            label: 'actions.selectAgents',
            agents: this.agentsCache.getAgents(this.agent.role).filter((agent) => agent.id !== this.agent.id),
            options: {
              mode: 'inline'
            },
            value: []
          })
        ]
      })
    ];
  }

  transferAccounts(value) {
    this.results = [];
    const request = value.agentIds.map((targetAgentId) => this.transferAccountsTo(targetAgentId));
    Promise.all(request).then((results) => {
      this.endSubmit();
      this.results = results;
    });
  }

  transferAccountsTo(targetAgentId) {
    const agent = this.agentsCache.getAgent(targetAgentId).email;
    return new Promise((resolve, reject) => {
      this.agentsService
        .transferAccounts(targetAgentId, this.agent.id)
        .then((res) => resolve({ ...res, agent }))
        .catch((error) => resolve({ done: false, agent, ...error }));
    });
  }

  endSubmit() {
    this.dynamicForm.setSpinner(false);
  }

  open() {
    this.modal.open();
  }
}
